export default __webpack_public_path__ + "static/2-e940bc6c973ea5d2f8c67d8b26b391a0.png";